module.exports = __webpack_public_path__ + "img/course (4).209e4bf4.png";